export default "__VITE_ASSET__DU9AjPNY__"